<template>
  <div class="errors-log-list-wrapper">
    <LogSearch v-model="errorsSearch" />

    <div ref="containerRef" class="errors-log-list" data-testid="logs-errors-list">
      <LogTable>
        <LogEntry
          v-for="entry in entries"
          :key="entry.id"
          :id="entry.id"
          level="error"
          :timestamp="entry.timestamp"
          :message="entry.message"
          :stack-trace="entry.stack"
          :active="entry.id === activeEntryId"
          @click="$emit('seek', entry.timestamp)"
        />
      </LogTable>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, toRef } from 'vue';
import LogSearch from './LogSearch.vue';
import LogTable from './LogTable.vue';
import LogEntry from './LogEntry.vue';
import { storeToRefs } from 'pinia';
import { useLogsStore } from '@/modules/viewer/store/useLogsStore';
import { useActiveLogEntry } from '@/modules/viewer/composables/useActiveLogEntry';

const props = defineProps<{
  autoScroll: boolean;
}>();

defineEmits<{
  seek: [timestamp: number];
}>();

const { filteredErrorEntries, errorsSearch } = storeToRefs(useLogsStore());
const entries = computed(() => filteredErrorEntries.value);

const { containerRef, activeEntryId } = useActiveLogEntry(entries, toRef(props, 'autoScroll'));
</script>

<style scoped>
.errors-log-list-wrapper {
  @apply flex flex-col;
}

.errors-log-list {
  @apply flex flex-col px-4 sm:px-5 pb-4;
}
</style>
